import { RootState } from '@reducers';

export const selectFeatureInsurancePolicyUser = (state: RootState) => state.featureReducer.insurancePolicyUserReducer;
